module.exports = __webpack_public_path__ + "static/media/DT-LOGO-2023-Reverse.6c34783d.png";